document.addEventListener('DOMContentLoaded', function() {
  var breakpoint = window.matchMedia('(max-width: 768px)');
  var sliders = document.querySelectorAll('[data-ico-list-carousel]');
  var swiperInstances = [];

  function enableSliders() {
    sliders.forEach(function(slider, index) {
      var nextButton = slider.querySelector('[data-slider-next]');
      var prevButton = slider.querySelector('[data-slider-prev]');
      var scrollSlider = slider.querySelector('.swiper');

      swiperInstances[index] = new Swiper(scrollSlider, {
        direction: 'horizontal',
        slidesPerView: "auto",
        mousewheelControl: true,
        spaceBetween: 24,
        speed: 400,
        breakpoints: {
          640: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 3
          },
        },
        // navigation: {
        //   nextEl: nextButton,
        //   prevEl: prevButton
        // }
        pagination: {
          el: ".swiper-pagination",
        },
      });
    });
  }

  function destroySliders() {
    swiperInstances.forEach(function(swiper) {
      if (swiper) {
        swiper.destroy(true, true);
      }
    });
    swiperInstances = [];
  }

  function handleBreakpointChange() {
    if (breakpoint.matches) {
      enableSliders();
    } else {
      destroySliders();
    }
  }

  breakpoint.addEventListener('change', handleBreakpointChange);

  handleBreakpointChange();
});
